'use strict';

var AbstractListResultView = require('components/common/views/abstract_list_result_view');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var OOP = require('utils/oop');

var templates = Misc.templateSet(require('components/profile/templates/device_report'));

module.exports = OOP.extend(
    AbstractListResultView,
    {
        initialize: function (options) {
            this.base.initialize(options);
        },

        events: function () {
            return _.extend({}, AbstractListResultView.prototype.events, {
                'click input.js-table-row-select': function (e) {
                    this.rowSelected(e);
                    this.updateSelectionButtonsLabel();
                },
                'click #js-toggle': function (e) {
                    var self = this;
                    this.controller.setReportDevicesActive(
                        this.collection.selected,
                        this.nrSelectedInactiveReports() > 0,
                        function () {
                            self.refreshTable();
                        },
                        function () {
                            Notification.show(
                                'warning',
                                i18n.TR('Warnung'),
                                i18n.TR('Die Berichte konnten nicht geändert werden.')
                            );
                        }
                    );
                },
                'click .js-tab-btn-add': function () {
                    this.controller.reportDevicesAdd();
                },
                'click .js-device-report-edit': function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var idx = $(e.currentTarget).data('id');
                    this.controller.reportDevicesEdit(idx);
                },
                'click .js-device-report-download': function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var idx = $(e.currentTarget).data('id');
                    var model = this.collection.get(idx);
                    this.controller.reportDevicesDownload(idx, model.get('name'));
                },
            });
        },

        onShow: function () {
            this.base.onShow();
            this.updateSelectionButtonsLabel();
        },

        onRender: function () {
            this.base.onRender();
            this.updateSelectionButtonsLabel();
        },

        nrSelectedInactiveReports: function () {
            return _.filter(this.collection.selected, function (r) {
                return !r.get('is_active');
            }).length;
        },

        updateSelectionButtonsLabel: function () {
            $('.js-tab-btn-toggle').html(
                this.nrSelectedInactiveReports() > 0 || this.collection.selectedLength == 0
                    ? '<i class="fa fa-check-square-o m-r-5"></i>' + i18n.TR('Aktivieren')
                    : '<i class="fa fa-square-o m-r-5"></i>' + i18n.TR('Deaktivieren')
            );
        },

        getTableConfiguration: function () {
            var self = this;
            return {
                title: i18n.TR('Geräteberichte'),
                columns: [
                    { id: '#_name', name: i18n.TR('Name'), alwaysVisible: true, displayMethod: 'name' },
                    {
                        id: '#_period',
                        name: i18n.TR('Periode'),
                        displayMethod: Misc.selectFieldFct(Consts.ReportPeriods, 'value', 'text'),
                    },
                    {
                        id: '#_format',
                        name: i18n.TR('Format'),
                        displayMethod: Misc.selectFieldFct(Consts.ReportFormats, 'value', function (item) {
                            return '<i class="' + item.icon + '"></i> ' + item.text;
                        }),
                    },
                    { id: '#_receivers', name: i18n.TR('Empfänger'), notSortable: true },
                    { id: '#_download', name: i18n.TR('Archiv'), displayMethod: 'download', notSortable: true },
                ],
                hasRefreshButton: true,
                hasSelectionButtons: true,
                selectionButtons: [
                    { ButtonText: i18n.TR('Aktivieren'), ButtonID: 'toggle' },
                    { ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' },
                ],
                customButtons: [
                    {
                        ButtonIcon: 'fa fa-plus',
                        ButtonID: 'add',
                    },
                ],
                displayMethods: {
                    name: function (value, obj) {
                        return templates.Name({
                            model: obj,
                            navigation: self.getNavigationLinks(obj),
                        });
                    },
                    download: function (value, obj) {
                        return templates.Download({
                            model: obj,
                        });
                    },
                },
            };
        },

        getNavigationLinks: function (obj) {
            return [
                { id: obj.id, name: i18n.TR('Bearbeiten'), icon: 'fa fa-edit', class: 'js-device-report-edit' },
                {
                    id: obj.id,
                    name: i18n.TR('Herunterladen'),
                    icon: 'fa fa-download',
                    class: 'js-device-report-download',
                    disabled: obj.files == 0,
                },
            ];
        },
    },
    'DeviceReportView'
);
